/* istanbul ignore file */
import communicationInit from './init'

export default communicationInit

export * from './types'
